import { createActionGroup } from '@ngrx/store';

export const LessonAPIActions = createActionGroup({
  source: 'Lesson API',
  events: {},
});
